import { PubSub } from '@aws-amplify/pubsub';
import { post } from '../axios/axiosGateway';

export const pubsub = new PubSub({
  region: process.env.REACT_APP_AWS_REGION,
  endpoint: process.env.REACT_APP_MQTT_URL,
});

export const attachPubsubPolicy = () => {
  const cognitoIdentityId = localStorage.getItem('cognitoIdentityId');
  return post(`/attach-pubsub-policy`, { cognitoIdentityId });
};
